import { calculateRect, measureNode } from '../utils.js';
import { resolveNode } from '../utils/responsive.js';

export class LayoutCalculator {
  static getRootDimensions(contextStack, containerNode, pageWidth = 1280, pageHeight = 720) {
    // Always return page dimensions to maintain global coordinate system
    // even when isolated. Visual isolation is handled by displayRoots.
    return {
      rootW: pageWidth,
      rootH: pageHeight,
      pageWidth,
      pageHeight
    };
  }

  static getParentDimensions(node, activeNodes, rootW, rootH, activeBreakpoint = 'default') {
    if (!node.parentId) {
      return { width: rootW, height: rootH };
    }

    const parent = activeNodes.find(n => n.id === node.parentId);
    if (!parent) {
      return { width: rootW, height: rootH };
    }

    const resolvedParent = resolveNode(parent, activeBreakpoint);
    const pRect = calculateRect(resolvedParent, rootW, rootH);
    return { width: pRect.width, height: pRect.height };
  }

  static calculateNodeRect(node, activeNodes, rootW, rootH, activeBreakpoint = 'default') {
    const parentSize = this.getParentDimensions(node, activeNodes, rootW, rootH, activeBreakpoint);
    const resolvedNode = resolveNode(node, activeBreakpoint);
    return calculateRect(resolvedNode, parentSize.width, parentSize.height);
  }

  static calculateBoundingBox(nodes, activeNodes, parentW, parentH, activeBreakpoint = 'default') {
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

    nodes.forEach(node => {
      const resolvedNode = resolveNode(node, activeBreakpoint);
      const rect = calculateRect(resolvedNode, parentW, parentH);
      if (rect.x < minX) minX = rect.x;
      if (rect.y < minY) minY = rect.y;
      if (rect.x + rect.width > maxX) maxX = rect.x + rect.width;
      if (rect.y + rect.height > maxY) maxY = rect.y + rect.height;
    });

    return {
      x: minX,
      y: minY,
      width: maxX - minX,
      height: maxY - minY
    };
  }

  static measureNodeById(nodeId, activeNodes, rootW, rootH, activeBreakpoint = 'default') {
    return measureNode(nodeId, activeNodes, rootW, rootH, activeBreakpoint);
  }
}
